// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__22Btk","title":"FrontImage_title__11gW9"};